import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../settings';
import { useNavigate } from 'react-router-dom';

// 👇️ pages
import Visitor_Home from './Visitor_Home';
import LoggedIn_Home from './LoggedIn_Home';

export default function Home({
    events,
    fetchEvents,
    announcements,
    jobPostings,
    alumni,
    photos,
    eventsError,
    announcementsError,
    jobPostsError,
    alumniError,
}) {
    const [alumni_isLoggedIn, setAlumni_isLoggedIn] = useState(false);
    const [alumniData, setAlumniData] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        // 👇️ going to check if alumni logged in.
        fetch(`${BASE_URL}/alumni`, {
            method: 'POST',
        })
            .then(async (result) => {
                let response = await result.json();
                // console.log('\nresponse:', response);
                if (response?.msg == "don't redirect") setAlumni_isLoggedIn(false);
                else {
                    if (response?.alumni) {
                        let data = response?.alumni;
                        setAlumniData(data);
                        // navigate(`/alumni/classes/${alumniData?.classYear}/${alumniData?.uuid}`);
                    }
                    setAlumni_isLoggedIn(true);
                }
            })
            .catch((error) => {
                console.log('alumni error:', error?.message, '\n', error);
            });
    }, []);

    // 👇️ handler to return the correct page based on if alumni is logged in or not
    const getPage = () => {
        if (alumni_isLoggedIn)
            return (
                <LoggedIn_Home
                    events={events}
                    fetchEvents={fetchEvents}
                    announcements={announcements}
                    jobPostings={jobPostings}
                    alumni={alumni}
                    photos={photos}
                    eventsError={eventsError}
                    announcementsError={announcementsError}
                    jobPostsError={jobPostsError}
                    alumniError={alumniError}
                    alumniData={alumniData}
                />
            );
        else
            return (
                <Visitor_Home
                    events={events}
                    fetchEvents={fetchEvents}
                    announcements={announcements}
                    jobPostings={jobPostings}
                    alumni={alumni}
                    photos={photos}
                    eventsError={eventsError}
                    announcementsError={announcementsError}
                    jobPostsError={jobPostsError}
                    alumniError={alumniError}
                />
            );
    };

    return getPage();
}
